import React from "react";
import { TouchableOpacity, Text } from "react-native";
import Ionicons from "react-native-vector-icons/Ionicons";

interface DummyDataToggleProps {
  useDummyData: boolean;
  onToggle: () => void;
}

/**
 * Toggle button for dummy/demo data mode
 */
export const DummyDataToggle: React.FC<DummyDataToggleProps> = ({
  useDummyData,
  onToggle,
}) => {
  return (
    <TouchableOpacity
      onPress={onToggle}
      style={{
        flexDirection: "row",
        alignItems: "center",
        padding: 6,
        backgroundColor: useDummyData ? "#FF6B35" : "#f0f0f0",
        borderRadius: 6,
        borderWidth: 1,
        borderColor: useDummyData ? "#FF6B35" : "#ddd",
      }}
    >
      <Ionicons
        name={useDummyData ? "flask" : "flask-outline"}
        size={16}
        color={useDummyData ? "white" : "#666"}
        style={{ marginRight: 4 }}
      />
      <Text
        style={{
          fontSize: 12,
          fontWeight: "500",
          color: useDummyData ? "white" : "#666",
        }}
      >
        {useDummyData ? "Demo Mode" : "Demo Data"}
      </Text>
    </TouchableOpacity>
  );
};
